import { FOOTER_CONTENT_LOAD, FOOTER_CONTENT_LOAD_SUCCESS, FOOTER_CONTENT_LOAD_FAIL } from './actions';

const initialState = {
  loaded: false,
  editing: {},
  saveError: {},
  data: [],
  extraData: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FOOTER_CONTENT_LOAD:
      return {
        ...state,
        loading: true,
      };
    case FOOTER_CONTENT_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: { actionType: 'footer', result: action.result },
        error: null,
        extraData: 'This is extra info..........',
      };
    case FOOTER_CONTENT_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    default:
      return state;
  }
}
